export default __webpack_public_path__ + "static/media/SelfHealRate.0f339f47.svg";